export const getForumData = (state) => state.forumData || {};
export const getCommunityId = (state) => getForumData(state).communityId;
export const getInstanceId = (state) => getForumData(state)._id;
export const getForumTitle = (state) => getForumData(state).label;
